<template>
    <select
        @input="event => { $emit('input', event.target.value) }"
        class="form-control"
        v-model="selectedOption"
    >
        <option value="PORTARIA">Portaria de Outorga</option>
        <option value="PROTOCOLO">Protocolo de Outorga</option>
        <option value="DISPENSA">Declaração de Dispensa</option>
    </select>
</template>

<script>
export default {
    name: 'tipoEspecial',
    props: {
        value: null,
        all: false,
    },
    data () {
        return {
            selectedOption: null
        }
    },
    mounted () {
        this.selectedOption = this.value
    },
    watch: {
        value: function (newValue) {
            this.selectedOption = newValue
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/custom/TipoEspecial.vue